import { Box, Flex, Image, Text, VStack } from "@chakra-ui/react";
import { Images } from "../../Assets/images";
import React, { useEffect, useState } from "react";
import { BsFillPersonFill } from "react-icons/bs";
import { BiSolidLockAlt } from "react-icons/bi";
import { IoLogOut } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { SellerAPI } from "../../Apis/sellerAPI";
import { errorHandler } from "../../Utils/handler";
import { useToastWrapper } from "../../Wrapper/toastWrapper";
import LogoutWarningModal from "../../Components/Modals/LogoutWarningModal";
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../redux/Actions";
import { handleLogout } from "../../Utils/logout"; // Claude: consistent logout with persistor.purge() 06-03-2026
import { formatVersion, getCachedServerHash } from "../../Utils/version"; // Claude: version display 28-03-2026
import { MdOutlineSupportAgent, MdWorkspacePremium, MdOutlineVisibility, MdOutlineFolder, MdArrowBack } from "react-icons/md";
import SupportModal from "../../Components/Modals/SupportModal";
import { Sellerscreens } from "../../Constants/data";

const Account = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  // Claude: verification badge next to My Profile 19-03-2026
  const verificationStatus = useSelector((state: any) => state.user?.verificationStatus);

  const [data, setData] = useState<any>();

  const { success, error } = useToastWrapper();

  const [logoutModal, setLogoutModal] = useState(false);

  const handleLogoutUser = () => {
    setLogoutModal(false);
    handleLogout(); // Claude: purges localStorage + redirects to /login 06-03-2026
  };

  const handleCloseLogoutModal = () => {
    setLogoutModal(false);
  };

  const handleOpenLogoutModal = () => {
    setLogoutModal(true);
  };

const [supportModal, setSupportModal] = useState(false);

  const handleOpenSupportModal = () => {
    setSupportModal(true);
  };

  const handleCloseSupportModal = () => {
    setSupportModal(false);
  };

  const getData = async () => {
    setLoading(true);
    try {
      const res = await SellerAPI.getSellerProfile();
      if (res) {
        console.log("Seller Profile is:",res);
        const planActive = !!(res.data.data?.subscriptionPlanId && res.data.data?.isPlanActive);
        const obj = {
          name: res.data.data?.personName,
          companyName: res.data.data?.companyName,
          designation: res.data.data?.personDesignation,
          workEmail: res.data.data?.personEmail,
          // socialEmail: res.data.data?.personEmail,
          phoneNumber: res.data.data?.personPhoneNumber,
          timezone: res.data.data?.companyTimezone,
          companyWebsite: res.data.data?.companyUrl,
          // Claude: visibility + subscription badges for account menu 12-03-2026
          visibilityMode: planActive ? (res.data.data?.visibilityMode || "open") : "restricted", // Claude: renamed invisible→restricted 11-Apr-2026
          planName: res.data.data?.planName || null,
          isPlanActive: planActive,
        };
        setData(obj);
      }
    } catch (err) {
      console.log(err);
      error(errorHandler(err));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
    dispatch(
      actions.sellerMenu.set({
        activeMenu: Sellerscreens.PROFILE
      })
    )
  }, []);

  // Claude: Redesigned to match other pages — dark header, white bg items, tighter layout 23-02-2026
  return (
    <Box w={"100%"} display={"flex"} flexDirection={"column"} minH={"100dvh"}>
      <Modal
        closeIcon={null}
        footer={null}
        title={null}
        open={logoutModal}
        onOk={handleCloseLogoutModal}
        onCancel={handleCloseLogoutModal}
      >
        <LogoutWarningModal
          handleCloseModal={handleCloseLogoutModal}
          handleSubmit={handleLogoutUser}
        />
      </Modal>
      <Modal
        closeIcon={null}
        footer={null}
        title={null}
        open={supportModal}
        onOk={handleCloseSupportModal}
        onCancel={handleCloseSupportModal}
      >
        <SupportModal handleCloseModal={handleCloseSupportModal} />
      </Modal>

      {/* Claude: AFTR logo on right side of dark header 23-02-2026 */}
      <Flex
        w={"100%"}
        px={"30px"}
        py={5}
        bg={"#0E122F"}
        color={"white"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        {/* Claude: back arrow → opportunities page 11-04-2026 */}
        <Flex alignItems="center" gap={3} cursor="pointer" onClick={() => navigate("/seller/rfxs")}>
          <MdArrowBack size={20} color="white" />
          <Text fontSize={"xl"} fontWeight={700}>Account Info</Text>
        </Flex>
        {/* Claude: role label below logo in header 25-02-2026 */}
        <VStack spacing={0} alignItems="center" justifyContent="center">
          <Image src={Images.AftrLogo} h="32px" objectFit="contain" />
          <Text fontSize="11px" fontWeight={300} color="whiteAlpha.600" letterSpacing="wide">
            seller (beta)
          </Text>

        </VStack>
      </Flex>

      {/* Menu items on white bg */}
      <VStack spacing={0} w={"100%"} bg={"white"}>
        <Box
          display={"flex"}
          alignItems={"center"}
          py={"10px"}
          px={"20px"}
          gap={3}
          w={"100%"}
          cursor={"pointer"}
          borderBottom={"1px solid #E2E8F0"}
          onClick={() => navigate("/seller/profile")}
        >
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            h={"36px"}
            w={"36px"}
            bg={"gray.100"}
            rounded={"10px"}
          >
            <BsFillPersonFill size={18} color={"#1C1B1F"} />
          </Box>
          <Text fontSize={"sm"} fontWeight={500} color={"gray.800"}>My Profile</Text>
          {/* Claude: verification status badge 19-03-2026 */}
          {verificationStatus === "unverified" && (
            <Text fontSize="10px" fontWeight={600} px={2} py="2px" borderRadius="6px" color="#9B2C2C" bg="#FED7D7">Unverified</Text>
          )}
          {(verificationStatus === "resubmitted" || verificationStatus === "provisional") && (
            <Text fontSize="10px" fontWeight={600} px={2} py="2px" borderRadius="6px" color="#7B341E" bg="#FEEBC8">Under Review</Text>
          )}
        </Box>

        {/* Claude: Profile Visibility menu item + current mode badge 12-03-2026 */}
        <Box display="flex" alignItems="center" py="10px" px="20px" gap={3} w="100%"
          cursor="pointer" borderBottom="1px solid #E2E8F0"
          onClick={() => navigate("/seller/visibility")}>
          <Box display="flex" alignItems="center" justifyContent="center"
            h="36px" w="36px" bg="gray.100" rounded="10px">
            <MdOutlineVisibility size={18} color="#1C1B1F" />
          </Box>
          <Text fontSize="sm" fontWeight={500} color="gray.800" flex={1}>Profile Visibility</Text>
          {data?.visibilityMode && (
            <Text fontSize="10px" fontWeight={600} px={2} py="2px" borderRadius="6px"
              color={data.visibilityMode === "open" ? "#155724" : data.visibilityMode === "targeted" ? "#4A1D96" : "#6B7280"}
              bg={data.visibilityMode === "open" ? "#D4EDDA" : data.visibilityMode === "targeted" ? "#EDE9FE" : "#F3F4F6"}>
              {data.visibilityMode === "open" ? "Open" : data.visibilityMode === "targeted" ? "Targeted" : "Restricted"}
            </Text>
          )}
        </Box>

        {/* Claude: Moved Subscriptions from nav bar to Account Info 23-02-2026 */}
        <Box
          display={"flex"}
          alignItems={"center"}
          py={"10px"}
          px={"20px"}
          gap={3}
          w={"100%"}
          cursor={"pointer"}
          borderBottom={"1px solid #E2E8F0"}
          onClick={() => navigate("/seller/seller-subscriptions")}
        >
          <Box display={"flex"} alignItems={"center"} justifyContent={"center"}
            h={"36px"} w={"36px"} bg={"gray.100"} rounded={"10px"}>
            <MdWorkspacePremium size={18} color={"#1C1B1F"} />
          </Box>
          <Text fontSize={"sm"} fontWeight={500} color={"gray.800"} flex={1}>
            Subscription Plan
          </Text>
          {/* Claude: subscription plan badge 12-03-2026 */}
          {data?.planName ? (
            <Text fontSize="10px" fontWeight={600} px={2} py="2px" borderRadius="6px"
              color={data.isPlanActive ? "#155724" : "#721C24"}
              bg={data.isPlanActive ? "#D4EDDA" : "#F8D7DA"}>
              {data.planName}
            </Text>
          ) : (
            <Text fontSize="10px" fontWeight={600} px={2} py="2px" borderRadius="6px"
              color="#6B7280" bg="#F3F4F6">
              No Plan
            </Text>
          )}
        </Box>

        {/* Claude: Catalog moved from nav to Account Info 14-03-2026 */}
        <Box
          display={"flex"}
          alignItems={"center"}
          py={"10px"}
          px={"20px"}
          gap={3}
          w={"100%"}
          cursor={"pointer"}
          borderBottom={"1px solid #E2E8F0"}
          onClick={() => navigate("/seller/catalog")}
        >
          <Box display={"flex"} alignItems={"center"} justifyContent={"center"}
            h={"36px"} w={"36px"} bg={"gray.100"} rounded={"10px"}>
            <MdOutlineFolder size={18} color={"#1C1B1F"} />
          </Box>
          <Text fontSize={"sm"} fontWeight={500} color={"gray.800"}>
            Catalog & Digital Assets
          </Text>
        </Box>

        <Box
          display={"flex"}
          alignItems={"center"}
          py={"10px"}
          px={"20px"}
          gap={3}
          w={"100%"}
          cursor={"pointer"}
          borderBottom={"1px solid #E2E8F0"}
          onClick={() => navigate("/reset-password")}
        >
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            h={"36px"}
            w={"36px"}
            bg={"gray.100"}
            rounded={"10px"}
          >
            <BiSolidLockAlt size={18} color={"#1C1B1F"} />
          </Box>
          <Text fontSize={"sm"} fontWeight={500} color={"gray.800"}>
            Change Password
          </Text>
        </Box>

        <Box
          display={"flex"}
          alignItems={"center"}
          py={"10px"}
          px={"20px"}
          gap={3}
          w={"100%"}
          cursor={"pointer"}
          borderBottom={"1px solid #E2E8F0"}
          onClick={() => handleOpenSupportModal()}
        >
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            h={"36px"}
            w={"36px"}
            bg={"gray.100"}
            rounded={"10px"}
          >
            <MdOutlineSupportAgent size={18} color={"#1C1B1F"} />
          </Box>
          <Text fontSize={"sm"} fontWeight={500} color={"gray.800"}>
            Support
          </Text>
        </Box>

        <Box
          display={"flex"}
          alignItems={"center"}
          py={"10px"}
          px={"20px"}
          gap={3}
          w={"100%"}
          cursor={"pointer"}
          onClick={() => handleOpenLogoutModal()}
        >
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            h={"36px"}
            w={"36px"}
            bg={"gray.100"}
            rounded={"10px"}
          >
            <IoLogOut size={18} color={"#1C1B1F"} />
          </Box>
          <Text fontSize={"sm"} fontWeight={500} color={"gray.800"}>
            Logout
          </Text>
        </Box>
        {/* Claude: version string below logout — pb clears bottom nav bar 28-03-2026 */}
        <Text fontSize={"10px"} color={"gray.400"} textAlign={"center"} mt={2} pb={"80px"}>
          {formatVersion(process.env.REACT_APP_GIT_HASH || '??', getCachedServerHash())}
        </Text>
      </VStack>
    </Box>
  );
};

export default Account;
